import { ModTooltip } from '@moderneinc/design-system-components';
import type { FunctionComponent, ReactElement } from 'react';
import { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

type CopyToClipBoardWithTooltipProps = {
  children: ReactElement | ((copied: boolean) => ReactElement);
  onCopy?: () => void;
  text: string;
  tooltip: string;
};

export const CopyToClipboardWithTooltip: FunctionComponent<
  CopyToClipBoardWithTooltipProps
> = ({ onCopy, children, tooltip, text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (): void => {
    if (onCopy) {
      onCopy();
    }
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1600);
  };

  const resolved = typeof children === 'function' ? children(copied) : children;

  return (
    <CopyToClipboard text={text} onCopy={handleCopy}>
      <ModTooltip title={copied ? 'Copied to clipboard' : tooltip}>
        {resolved}
      </ModTooltip>
    </CopyToClipboard>
  );
};
